import { connectRefinementList } from 'instantsearch.js/es/connectors'
// Source : https://www.algolia.com/doc/api-reference/widgets/refinement-list/js/#full-example

// Create the render function
const renderRefinementList = (renderOptions, isFirstRender) => {
    const {
        items,
        isFromSearch,
        refine,
        createURL,
        isShowingMore,
        canToggleShowMore,
        searchForItems,
        toggleShowMore,
        widgetParams,
    } = renderOptions;

    let viewType = $('.tematik_produits').data('view-type');
    let isSpecialViewType = (viewType, attribute) => {
        if ((viewType === 'modeConsommationView' && attribute === 'mode_de_consommation') || (viewType === 'marqueView' && attribute === 'marque')) {
            return true;
        }
        return false;
    }

    if (isSpecialViewType(viewType, widgetParams.attribute)) {
        widgetParams.header.parentNode.style.display = "block";
        widgetParams.header.style.display = "block";
        widgetParams.container.style.display = "block";
        
        let container = widgetParams.container.querySelector('.filtres-content-interne');
        container.innerHTML = '';
        items.map(item => {
            container.innerHTML += `
                <div class="ais-refinement-list--item ${item.isRefined ? 'ais-refinement-list--item__active' : ''}">
                    <div>
                        <label class="ais-refinement-list--label">
                            <input type="checkbox" ${item.isRefined ? 'checked' : ''} class="ais-refinement-list--checkbox" data-value="${item.value}">
                            ${item.label}
                            <span class="ais-refinement-list--count">(${item.count})</span>
                        </label>
                    </div>
                </div>
            `;
        });
        [...widgetParams.container.querySelectorAll('.ais-refinement-list--checkbox')].forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });
        
    // Pour un type de filtre, si 1 seul filtre est sélectionné ou qu'aucun filtre ne correspond à la recherche en cours on masque le filtres
    } else if ((widgetParams.filtres && widgetParams.filtres.length === 1) || (items.length === 0) || (viewType.length > 0)) {
        widgetParams.header.parentNode.style.display = "none";
        widgetParams.header.style.display = "none";
        widgetParams.container.style.display = "none";

    // Pour un type de fitlre, si plus d'un filtre est sélectionné, on affiche le block et les filtres sélectionnés
    } else if (widgetParams.filtres && widgetParams.filtres.length >= 2) {
        widgetParams.header.parentNode.style.display = "block";
        widgetParams.header.style.display = "block";
        widgetParams.container.style.display = "block";
        let container = widgetParams.container.querySelector('.filtres-content-interne');
        container.innerHTML = '';
        items.map(item => {
            Object.values(widgetParams.filtres).forEach(val => {
                if ((item.count > 0) && (item.label === val)) {
                    container.innerHTML += `
                        <div class="ais-refinement-list--item ${item.isRefined ? 'ais-refinement-list--item__active' : ''}">
                            <div>
                                <label class="ais-refinement-list--label">
                                    <input type="checkbox" ${item.isRefined ? 'checked' : ''} class="ais-refinement-list--checkbox" data-value="${item.value}">
                                    ${item.label}
                                    <span class="ais-refinement-list--count">(${item.count})</span>
                                </label>
                            </div>
                        </div>
                    `;
                }
            })
        });
        [...widgetParams.container.querySelectorAll('.ais-refinement-list--checkbox')].forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });

    // Si non, aucun filtre n'a été sélectionné dans le bloc, on mappe sur les filtres dispo pour la recherche en cours
    } else {
        widgetParams.header.parentNode.style.display = "block";
        widgetParams.header.style.display = "block";
        widgetParams.container.style.display = "block";
        widgetParams.container.querySelector('.filtres-content-interne').innerHTML = `
        ${items.map(
            item => `
            ${item.count > 0 ? `
                <div class="ais-refinement-list--item ${item.isRefined ? 'ais-refinement-list--item__active' : ''}">
                    <div>
                        <label class="ais-refinement-list--label">
                            <input type="checkbox" ${item.isRefined ? 'checked' : ''} class="ais-refinement-list--checkbox" data-value="${item.value}">
                            ${item.label}
                            <span class="ais-refinement-list--count">(${item.count})</span>
                        </label>
                    </div>
                </div>
            
            ` : '' }
            `
            ).join('')
        }
        `;
        [...widgetParams.container.querySelectorAll('.ais-refinement-list--checkbox')].forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                refine(event.currentTarget.dataset.value);
            });
        });
    }
    
}

const customRefinementList = connectRefinementList(renderRefinementList);

export default customRefinementList;